<template>
    <div>
        <v-tooltip-wrapper :disabled="!tooltip">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    icon
                    color="primary"
                    :disabled="disabled"
                    v-bind="attrs"
                    v-on="on"
                    @click="$emit('click')"
                >
                    <v-icon :size="size">{{ icon }}</v-icon>
                </v-btn>
            </template>
            <div class="icon-in-tooltip-container">
                {{ tooltip }}
            </div>
        </v-tooltip-wrapper>
    </div>
</template>

<script>
import VTooltipWrapper from "../../../../common/v-tooltip-wrapper.vue";

export default {
    name: 'calendar-event-menu-icon',
    components: {VTooltipWrapper},
    props: {
        icon: {
            type: String,
            required: true
        },
        tooltip: {
            type: String,
            default: ''
        },
        size: {
            type: [String, Number],
            default: 'default'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
